export function handleMarquee() {
    const marquee = document.querySelectorAll('.marquee-line');
    let speed = 0.35;
    let lastScrollPos = 0;
    let timer;

    marquee.forEach(function (el) {
        const container = el.querySelector('.marquee-inner');
        const content = el.querySelector('.marquee-inner > *');
        //Get total width
        const elWidth = content.offsetWidth;


        //Duplicate content
        for (let i = 0; i < 5; i++) {
            let clone = content.cloneNode(true);
            container.appendChild(clone)
        }

        let progress = 1;
        function loop() {
            progress = progress - speed;
            if (progress <= elWidth * -1) { progress = 0; }
            container.style.transform = 'translateX(' + progress + 'px)';

            window.requestAnimationFrame(loop);
        }
        loop();
    });

    function handleSpeedClear() {
        speed = 4;
    }
};